import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { ProductThumbnailProps } from './types';
import {
  StyledProductImage,
  StyledProductThumbnail,
  StyledProductThumbnailEmpty,
} from './styles';
import { IconBox } from '../../../assets/svg/icons';
import ProductMonogram from '../ProductMonogram';

const isMissingSrc = (src?: string | null) =>
  !src || src === '' || /add-image\.(png|jpe?g|svg)/i.test(src);

const ProductThumbnail: React.FC<ProductThumbnailProps> = ({
  src,
  alt,
  isBig,
  monogramName,
}) => {
  const intl = useIntl();
  const [failed, setFailed] = useState(false);
  const showEmpty = isMissingSrc(src) || failed;
  const imgAlt = showEmpty
    ? intl.formatMessage({
        id: 'orders.addImage',
        defaultMessage: 'No image',
      })
    : alt;

  return (
    <StyledProductThumbnail {...{ isBig }}>
      {showEmpty ? (
        <StyledProductThumbnailEmpty role='img' aria-label={imgAlt}>
          {monogramName ? (
            <ProductMonogram name={monogramName} scale={isBig ? 0.7 : 0.45} />
          ) : (
            <IconBox />
          )}
        </StyledProductThumbnailEmpty>
      ) : (
        <StyledProductImage
          src={src as string}
          alt={imgAlt}
          onError={() => setFailed(true)}
        />
      )}
    </StyledProductThumbnail>
  );
};

export default ProductThumbnail;
